import { combineEpics, ofType } from 'redux-observable';
import { of } from 'rxjs';
import { switchMap, takeUntil, map, catchError } from 'rxjs/operators';

import { getPreArrivalPreference$, updatePreArrivalPreference$ } from 'api/axp';
import {
	fetchPreArrivalPreference,
	fetchPreArrivalPreferenceFulfilled,
	fetchPreArrivalPreferenceCancel,
	fetchPreArrivalPreferenceFailed,
	updatePreArrivalPreference,
	updatePreArrivalPreferenceFulfilled,
	updatePreArrivalPreferenceCancel,
	updatePreArrivalPreferenceFailed,
} from './preArrivalPreference.slice';

const fetchPreArrivalPreferenceEpic = (action$, _state$) =>
	action$.pipe(
		ofType(fetchPreArrivalPreference.type),
		switchMap(({ payload: { bookingId } }) =>
			getPreArrivalPreference$({ bookingId }).pipe(
				map(fetchPreArrivalPreferenceFulfilled),
				catchError(error => of(fetchPreArrivalPreferenceFailed(error))),
				takeUntil(action$.pipe(ofType(fetchPreArrivalPreferenceCancel.type)))
			)
		)
	);

const updatePreArrivalPreferenceEpic = (action$, _state$) =>
	action$.pipe(
		ofType(updatePreArrivalPreference.type),
		switchMap(({ payload: { guestEta, stayReasonIds, guests, comments, bookingId } }) =>
			updatePreArrivalPreference$({
				guestEta,
				stayReasonIds,
				guests,
				comments,
				bookingId,
			}).pipe(
				map(response => updatePreArrivalPreferenceFulfilled(response.response)),
				catchError(error => of(updatePreArrivalPreferenceFailed(error))),
				takeUntil(action$.pipe(ofType(updatePreArrivalPreferenceCancel.type)))
			)
		)
	);

export default combineEpics(fetchPreArrivalPreferenceEpic, updatePreArrivalPreferenceEpic);
